import * as React from "react";
import { Backdrop, Box, CircularProgress, IconButton, Typography, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { UploadIcon } from "../../../components/icons";
import { baseColors } from "../../../Themes/colors";
import { WIZARD_COLORS } from "../../../components/FormComponents/dynamicForm";
import smartAutofillIcon from "../../../assets/images/smart-auto-fill.png";
import docScannerImage from "../../../assets/images/DocScanner.png";
import docScanAnimateImage from "../../../assets/images/DocScannAnimate.png";
var DEFAULT_ACCEPT = ".pdf,.jpg,.jpeg,.png";
var SCAN_BEAM_SX = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "30%",
    objectFit: "cover",
    objectPosition: "top",
    opacity: 0.9,
    "@keyframes scanBeam": {
        "0%": { top: "0%", opacity: 0.9 },
        "80%": { top: "70%", opacity: 0.85 },
        "100%": { top: "70%", opacity: 0 },
    },
    animation: "scanBeam 1.4s ease-in-out infinite",
};
var SmartAutofillBanner = function (_a) {
    var sources = _a.sources, selectedFileNames = _a.selectedFileNames, scanningSourceKey = _a.scanningSourceKey, isDisabled = _a.isDisabled, onFileSelect = _a.onFileSelect, onFileRemove = _a.onFileRemove;
    var inputRefs = React.useRef({});
    return (React.createElement(React.Fragment, null,
        React.createElement(Backdrop, { open: Boolean(scanningSourceKey), sx: {
                zIndex: function (theme) { return theme.zIndex.drawer + 1; },
                flexDirection: "column",
                gap: 2,
            } },
            React.createElement(Box, { sx: { position: "relative", width: 90, height: 106 } },
                React.createElement(Box, { component: "img", src: docScannerImage, alt: "", sx: {
                        width: 90,
                        height: 106,
                        objectFit: "contain",
                        display: "block",
                    } }),
                React.createElement(Box, { component: "img", src: docScanAnimateImage, alt: "", sx: SCAN_BEAM_SX })),
            React.createElement(Typography, { fontSize: 13, fontWeight: 500, sx: { color: "#fff" } }, "Scanning document...")),
        React.createElement(Box, { className: "autofill-banner" },
            React.createElement(Box, { component: "img", src: smartAutofillIcon, alt: "", sx: { width: 26, height: 26, flexShrink: 0, objectFit: "contain" } }),
            React.createElement(Box, { className: "autofill-copy" },
                React.createElement(Typography, { sx: { fontSize: 14, fontWeight: 700, color: WIZARD_COLORS.ink } }, "Smart Autofill Enabled"),
                React.createElement(Typography, { sx: { fontSize: 12, color: WIZARD_COLORS.muted } }, "Upload Documents to Auto fill your Application. All Fields Remain Editable")),
            sources.map(function (source) {
                var _a;
                var selectedFileName = selectedFileNames[source.key];
                var isScanning = scanningSourceKey === source.key;
                var isZoneDisabled = Boolean(isDisabled) || isScanning || Boolean(selectedFileName);
                return (React.createElement(Box, { key: source.key, component: "button", type: "button", className: "autofill-drop", disabled: isZoneDisabled, onClick: function () { var _a; return (_a = inputRefs.current[source.key]) === null || _a === void 0 ? void 0 : _a.click(); } },
                    isScanning ? (React.createElement(CircularProgress, { size: 16, sx: { color: WIZARD_COLORS.muted } })) : (React.createElement(UploadIcon, { sx: { fontSize: 18, color: WIZARD_COLORS.muted } })),
                    React.createElement(Typography, { sx: {
                            fontSize: 13,
                            color: selectedFileName
                                ? baseColors.successPreset[30]
                                : WIZARD_COLORS.ink,
                            flex: 1,
                            textAlign: "left",
                        }, noWrap: true, title: selectedFileName || undefined }, isScanning
                        ? "Reading document…"
                        : selectedFileName || source.label),
                    selectedFileName && onFileRemove ? (React.createElement(IconButton, { size: "small", "aria-label": "Remove ".concat(source.label), component: "span", sx: { color: "error.main", p: 0.25, flexShrink: 0 }, onClick: function (event) {
                            event.stopPropagation();
                            onFileRemove(source.key);
                        } },
                        React.createElement(CloseIcon, { sx: { fontSize: 16 } }))) : (React.createElement(Typography, { sx: {
                            fontSize: 13,
                            fontWeight: 600,
                            color: baseColors.successPreset[30],
                            flexShrink: 0,
                        } }, isScanning ? "" : "Choose File")),
                    React.createElement("input", { ref: function (element) {
                            inputRefs.current[source.key] = element;
                        }, type: "file", hidden: true, disabled: isZoneDisabled, accept: (_a = source.accept) !== null && _a !== void 0 ? _a : DEFAULT_ACCEPT, "aria-label": source.label, onChange: function (event) {
                            var _a;
                            var selectedFile = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
                            if (selectedFile) {
                                onFileSelect(source.key, selectedFile);
                            }
                            event.target.value = "";
                        } })));
            }))));
};
export default React.memo(SmartAutofillBanner);
